// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"95":"fae3c74a","99":"d45c9ac4","197":"1a57acbe","259":"d42b4e67","381":"f9a35d9e","507":"8302fcc7","720":"a8056dda","754":"e94e191e","967":"4f9ddf8b","974":"16010a90"}[chunkId] + ".chunk.js";
};